export const transaction_routes = [
  {
    path: "/transactions",
    component: () => import("../Main.vue"),
    name: "Extratos"
  }
];

export default {};
